import type { JSONSchema7 } from 'json-schema';

export type BudgetTimePeriod = {
  start: string;
  end: string;
};

export type BudgetEntry = {
  name: string;
  amount?: number;
  timePeriod: BudgetTimePeriod;
  timeGrain: 'Annually';
  alertThresholds: Array<{
    threshold: number;
    operator: 'GreaterThan';
  }>;
};

export const BudgetSeriesFieldSchema = {
  uiOptions: {
    type: 'object',
    properties: {},
  } as JSONSchema7,
  returnValue: {
    title: 'Five Year Budgets',
    type: 'array',
    minItems: 5,
    maxItems: 5,
    items: {
      type: 'object',
      required: ['name', 'amount', 'timePeriod'],
      properties: {
        name: { type: 'string' },
        amount: { type: 'number' },
        timeGrain: { type: 'string', default: 'Annually' },
        alertThresholds: {
          type: 'array',
          default: [{ threshold: 90, operator: 'GreaterThan' }],
          items: {
            type: 'object',
            required: ['threshold', 'operator'],
            properties: {
              threshold: { type: 'number', default: 90 },
              operator: { type: 'string', default: 'GreaterThan' },
            },
          },
        },
        timePeriod: {
          type: 'object',
          required: ['start', 'end'],
          properties: {
            start: { type: 'string', format: 'date' },
            end: { type: 'string', format: 'date' },
          },
        },
      },
    },
  } as JSONSchema7,
};
